/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Aria_Cta_ButtonsInputs */

const en_nav_aria_cta_buttons = /** @type {(inputs: Nav_Aria_Cta_ButtonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Call to action buttons`)
};

const es_nav_aria_cta_buttons = /** @type {(inputs: Nav_Aria_Cta_ButtonsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Botones de llamada a la acción`)
};

/**
* | output |
* | --- |
* | "Call to action buttons" |
*
* @param {Nav_Aria_Cta_ButtonsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_aria_cta_buttons = /** @type {((inputs?: Nav_Aria_Cta_ButtonsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Aria_Cta_ButtonsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_aria_cta_buttons(inputs)
	return en_nav_aria_cta_buttons(inputs)
});